export default {
  box: {
    'maximize': 'Maximizar',
    'minimize': 'Minimizar'
  }
}
